import React from 'react'
import { useSelector } from 'react-redux'
import { selectFirstName } from '../../services/user/selectors'
import { oracleMarkdownToHtml } from '../../services/markdown/index'
import { useTranslatedText } from '../OracleCommons/StaticTextContext'
import { useFakeStream } from './hooks'

export interface OracleGuideOnSideWelcomeProps {
  className?: string
}

/**
 * Welcome message component for Guide on the Side.
 *
 * Displays a personalized welcome message when there is no chat history.
 * If the user's first name is available, it will be included in the greeting.
 */
export const OracleGuideOnSideWelcome: React.FC<OracleGuideOnSideWelcomeProps> = ({
  className,
}) => {
  const rawFirstName = useSelector(selectFirstName)
  const firstName = rawFirstName?.trim() || ''

  // Use the appropriate translation key based on whether we have a first name
  const messageKey = firstName ? 'messageWithName' : 'message'
  const message = useTranslatedText({
    keys: ['gotsWelcome', messageKey],
    params: firstName ? { name: firstName } : {},
  })

  // Fake-stream the message text (typewriter effect, plays once per mount)
  const { displayedText } = useFakeStream({ text: message })

  // Convert the progressively-revealed text to HTML
  const htmlContent = oracleMarkdownToHtml({ markdown: displayedText })
  const htmlString = Array.isArray(htmlContent) ? htmlContent.join('') : htmlContent || ''

  return (
    <div className={className}>
      <div
        className="oracle-guide-on-side-welcome__text"
        dangerouslySetInnerHTML={{ __html: htmlString }}
      />
    </div>
  )
}
